import React from "react";

interface State {
  footerSpaceHeight: number;
}

export default class FooterComponent extends React.Component<unknown, State> {
  private footerHeightChangeTimeout: NodeJS.Timeout | undefined;

  public constructor(props: unknown) {
    super(props);

    this.state = {
      footerSpaceHeight: 0,
    };
  }

  public componentDidMount = (): void => {
    this.updateFooterSpaceHeight();

    this.footerHeightChangeTimeout = setInterval((): void => {
      this.updateFooterSpaceHeight();
    }, 100);
  };

  public componentWillUnmount = (): void => {
    if (this.footerHeightChangeTimeout) {
      clearTimeout(this.footerHeightChangeTimeout);
    }
  };

  public updateFooterSpaceHeight = (): void => {
    const boundaried = document.getElementById("main-footer")?.getBoundingClientRect();
    if (boundaried) {
      this.setState({ footerSpaceHeight: boundaried.height });
    }
  };

  public render = (): JSX.Element => {
    const { footerSpaceHeight } = this.state;

    return (
      <>
        <div className="overlap-breaker" style={{ height: footerSpaceHeight }} />
        <footer
          id="main-footer"
          style={{
            position: "absolute",
            width: "100%",
            bottom: "0",

            paddingBottom: "0px !important",
          }}
        >
          <div className="container-fluid">
            <div
              className="row justify-content-center align-items-center text-white"
              style={{ height: "50px", background: "#223340" }}
            >
              © Jungle Juice. All Rights Reserved
            </div>
          </div>
        </footer>
      </>
    );
  };
}
